import { z } from "zod";

export const userOnboardingWorkStates = [
  "AgreementRequired",
  "PreparingProposal",
  "ProposalInProgress",
  "Finalizing",
  "StaffResolutionRequired",
  "Completed",
  "Closed",
] as const;

export type UserOnboardingWorkState = (typeof userOnboardingWorkStates)[number];

export const UserOnboardingWorkSchema = z.object({
  requestId: z.uuid(),
  workflowVersion: z.number().int(),
  state: z.enum(userOnboardingWorkStates),
  templateId: z.string().min(1),
  templateVersion: z.string().min(1),
  configuredParticipationMode: z.string().min(1),
  effectiveParticipationMode: z.string().min(1),
  currentProposalId: z.uuid().nullish(),
  currentNegotiationId: z.uuid().nullish(),
  relatedProposalIds: z.array(z.uuid()),
  workAgreementId: z.uuid().nullish(),
  closedByUserId: z.uuid().nullish(),
  closedDate: z.string().nullish(),
  closureReason: z.string().nullish(),
  /** Why provisioning gave the request to staff, e.g. `retry_age_exceeded`. Only then can staff retry it. */
  provisioningStaffResolutionReason: z.string().nullish(),
});

export type UserOnboardingWork = z.infer<typeof UserOnboardingWorkSchema>;
